<template>
  <div class="sm:border-b sm:border-gray-400 sm:pb-5 mb-5">
    <h3 class="text-lg leading-6 font-semibold text-blue-600">Price Options</h3>
    <p class="mt-1 max-w-2xl text-sm text-gray-600">
      Create a single price or create tiered pricing whatever suits you.
    </p>
  </div>

  <form-request
    :action="src"
    v-slot="{ update, submit, errors }"
  >
    <div class="grid grid-cols-12 gap-6 sm:mb-5">
      <div class="input-group col-span-12 sm:col-span-3">
        <label for="sale_price">Sale Price</label>
        <input
          type="text"
          id="sale_price"
          v-model="form.sale_price"
        />
        <error
          :errors="errors"
          name="sale_price"
        />
      </div>

      <div class="input-group col-span-12 sm:col-span-3">
        <label for="unit_price"> Unit Price </label>
        <input
          type="text"
          id="unit_price"
          v-model="form.unit_price"
        />
        <error
          :errors="errors"
          name="unit_price"
        />
      </div>

      <div class="input-group col-span-12 sm:col-span-3">
        <label for="unit_cost"> Unit Cost </label>
        <input
          type="text"
          id="unit_cost"
          v-model="form.unit_cost"
        />
        <error
          :errors="errors"
          name="unit_cost"
        />
      </div>

      <div class="input-group col-span-12 sm:col-span-3">
        <label for="pricing_concentration"> Concentration </label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <input
            type="text"
            id="pricing_concentration"
            v-model="form.pricing_concentration"
          />
          <div class="absolute inset-y-0 right-0 flex items-center">
            <label
              for="pricing_unit"
              class="sr-only"
              >UoM</label
            >

            <select
              id="pricing_unit"
              v-model="form.pricing_unit"
              class="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-600 sm:text-sm rounded-md"
            >
              <option value="g">g</option>
              <option value="mg">mg.</option>
              <option value="oz">oz.</option>
              <option value="lb">lb.</option>
            </select>
          </div>
        </div>
        <error
          :errors="errors"
          name="concentration"
        />
        <error
          :errors="errors"
          name="available_uom"
        />
      </div>
      <div class="">
        <button
          @click="submitPrice(update, submit)"
          class="inline-flex items-center px-4 py-2 mr-3 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Submit
        </button>
      </div>
    </div>
  </form-request>
</template>

<script>
import FormRequest from '@/Components/Forms/FormRequest'
import Error from '@/Components/Forms/Error'

export default {
  name: 'media-form',
  components: { FormRequest, Error },
  props: {
    /**
     * The route to send the updated pricing to
     */
    src: {
      type: String,
      required: true
    },

    /**
     * The package model
     */
    package: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      form: {
        sale_price: this.package.sale_price,
        unit_price: this.package.unit_price,
        unit_cost: this.package.unit_cost,
        pricing_concentration: this.package.pricing_concentration,
        pricing_unit: this.package.pricing_unit || 'g'
      }
    }
  },

  methods: {
    /**
     * Sends a request to the server with updated pricing information
     * @param update the function (provided by form-request component) to set the form params to send.
     * @param submit the function (provided by form-request component) that we use to send the http request
     */
    submitPrice(update, submit) {
      update(this.form)
      submit()
    }
  }
}
</script>
